<template>
	<vx-card :title="$t('Schedule.Visit')" class="mb-2" id="event-settings">
		<p>{{ $t("Follower.SelectEventText") }}</p>

		<div
			class="
				mt-4
				rounded
				text-primary
				w-full
				p-1
				border border-b-1 border-l-1 border-r-1 border-solid
				d-theme-border-grey-light
			"
			v-if="event.id"
		>
			<vs-collapse>
				<vs-collapse-item>
					<div slot="header">
						<div class="flex items-center gap-4">
							<vs-chip :color="resolveStatusColor">{{ resolveStatus }}</vs-chip>
							<p>
								{{ event.activity_name | title }} - {{ event.init_hour }} - {{ event.visit_point_name }}
							</p>
						</div>
					</div>
					<vs-list>
						<vs-list-header :title="$t('VisitPoint')"></vs-list-header>
						<vs-list-item
							icon-pack="feather"
							icon="icon-credit-card"
							:subtitle="event.visit_point_name | title"
						>
						</vs-list-item>
						<vs-list-item
							icon-pack="feather"
							icon="icon-credit-card"
							:subtitle="event.visit_point_identification"
						>
						</vs-list-item>
						<vs-list-item icon-pack="feather" icon="icon-globe" :subtitle="event.fullAddress()">
						</vs-list-item>
						<vs-list-item icon-pack="feather" icon="icon-map-pin" :subtitle="$t('Reports.location')">
							<p>
								<a
									title="Ver ubicación en Here Maps"
									:href="hereMapsUrl"
									target="_blank"
									style="margin: 10px 0px 10px 0px; color: #007bff; text-decoration: none"
									>Here Maps</a
								>
							</p>
						</vs-list-item>

						<vs-list-header :title="$t('Hour')"></vs-list-header>
						<vs-list-item icon-pack="feather" icon="icon-clock" :subtitle="event.init_hour"> </vs-list-item>
						<vs-list-item icon-pack="feather" icon="icon-clock" :subtitle="event.end_hour"> </vs-list-item>
						<vs-list-item icon-pack="feather" icon="icon-calendar" :subtitle="event.date_prog">
						</vs-list-item>

						<vs-list-header :title="$t('Activity.Activity')"></vs-list-header>
						<vs-list-item icon-pack="feather" icon="icon-tag" :subtitle="event.activity_name">
						</vs-list-item>
					</vs-list>
				</vs-collapse-item>
			</vs-collapse>
		</div>

		<vs-alert icon-pack="feather" icon="icon-info" color="warning" :active="!event.id" class="mt-4">
			{{ $t("Follower.event_id_error") }}
		</vs-alert>

		<div class="flex justify-start flex-wrap">
			<vs-button
				icon-pack="feather"
				icon="icon-calendar"
				class="mt-4 mr-2 shadow-lg"
				@click="isPopupActive = true"
				>{{ $t("Follower.SelectVisit") }}</vs-button
			>
		</div>

		<vs-popup
			:title="$t('Schedule.SelectResource')"
			:active.sync="isPopupActive"
			:width="400"
			class="vs-popup--content-custom"
		>
			<FollowerFormResourceSelection @selectedResource="handleSelectedResource" />

			<vs-popup :title="$t('Follower.SelectVisit')" :active.sync="isPopupActive2">
				<FollowerFormEventSelection :resource-id="resourceId" @select="handleSelectedEvent" />
			</vs-popup>
		</vs-popup>
	</vx-card>
</template>

<script>
import FollowerFormEventSelection from "./FollowerFormEventSelection.vue";
import FollowerFormResourceSelection from "./FollowerFormResourceSelection.vue";

export default {
	name: "FollowerFormEvent",
	components: {
		// component components
		FollowerFormResourceSelection,
		FollowerFormEventSelection,
	},
	props: {
		event: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			isPopupActive: false,
			isPopupActive2: false,
			resource: null,
			resourceId: 0,
		};
	},

	computed: {
		hereMapsUrl() {
			return `https://share.here.com/l/${this.event.coordinates()}`;
		},
		resolveStatus() {
			const status = this.event.event_status_id;
			const statusMap = {
				1: this.$t("Schedule.NotAssigned"),
				2: this.$t("Schedule.Scheduled"),
				3: this.$t("Schedule.ReProgramming"),
				4: this.$t("Schedule.Delayed"),
				5: this.$t("Schedule.OnTheWay"),
				6: this.$t("Schedule.InProgress"),
				7: this.$t("Schedule.Finished"),
				8: this.$t("Schedule.Canceled"),
			};
			return statusMap[status] || this.$t("Schedule.NotAssigned");
		},
		resolveStatusColor() {
			const status = this.event.event_status_id;
			const statusMap = {
				1: "#886ce4",
				2: "#28c76f",
				3: "#006eff",
				4: "#ff7070",
				5: "#ffbe81",
				6: "#ff7070",
				7: "#ff9f43",
				8: "#ff0000",
			};
			return statusMap[status] || "#a0a0a0";
		},
	},
	methods: {
		handleActions(action) {
			this.$emit("actions", action);
		},
		handleSelectedResource(resource) {
			this.resource = resource;
			this.isPopupActive2 = true;
			this.resourceId = resource.id;
		},
		handleSelectedEvent(event) {
			this.$emit("select", event);
			this.isPopupActive2 = false;
			this.isPopupActive = false;
		},
	},
};
</script>

<style scoped lang="scss"></style>
